var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00008 1.33301C5.05456 1.33301 2.66675 4.0014 2.66675 6.99967C2.66675 9.97446 4.36896 13.2079 7.02479 14.4493C7.64391 14.7387 8.35625 14.7387 8.97537 14.4493C11.6312 13.2079 13.3334 9.97446 13.3334 6.99967C13.3334 4.0014 10.9456 1.33301 8.00008 1.33301ZM8.00008 7.99967C8.73646 7.99967 9.33341 7.40272 9.33341 6.66634C9.33341 5.92996 8.73646 5.33301 8.00008 5.33301C7.2637 5.33301 6.66675 5.92996 6.66675 6.66634C6.66675 7.40272 7.2637 7.99967 8.00008 7.99967Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.859835a285269c98b24b74c08436ed97.svg";
export { ForwardRef as ReactComponent };